(() => {
  if (customElements.get('zoo-content-guide')) return;
  const focusSelector = 'a[href],button,input,select,textarea,[tabindex],[contenteditable="true"],summary';
  class ZooContentGuide extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('.zoo-content-guide__body');
      this.button = this.querySelector('.zoo-content-guide__toggle');
      if (!this.body || !this.button || this.active) return;
      this.active = true;
      this.expanded = false;
      this.savedTabs = new Map();
      this.onClick = () => { this.expanded = !this.expanded; this.update(); };
      this.onResize = () => this.measure();
      this.button.addEventListener('click', this.onClick);
      window.addEventListener('resize', this.onResize, {passive: true});
      this.body.addEventListener('load', this.onResize, true);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.onResize);
        this.observer.observe(this.body);
      }
      document.fonts?.ready.then(() => { if (this.active) this.measure(); });
      this.measure();
    }
    disconnectedCallback() {
      this.active = false;
      this.observer?.disconnect();
      window.removeEventListener('resize', this.onResize);
      this.button?.removeEventListener('click', this.onClick);
      this.body?.removeEventListener('load', this.onResize, true);
      this.restoreTabs();
      this.classList.remove('is-collapsed');
      if (this.button) { this.button.hidden = true; this.button.setAttribute('aria-expanded', 'true'); }
    }
    restoreTabs() {
      this.savedTabs?.forEach((value, node) => {
        if (value === null) node.removeAttribute('tabindex');
        else node.setAttribute('tabindex', value);
      });
      this.savedTabs?.clear();
    }
    measure() {
      if (!this.active || !this.body.clientWidth) return;
      const style = getComputedStyle(this.body);
      const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.65;
      const lines = Math.max(5, Math.min(15, parseInt(this.dataset.previewLines, 10) || 10));
      this.previewHeight = lineHeight * lines + (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);
      this.overflow = this.body.scrollHeight > this.previewHeight + 2;
      this.body.style.setProperty('--zoo-guide-preview-height', `${this.previewHeight}px`);
      this.update();
    }
    update() {
      this.restoreTabs();
      const active = this.ownerDocument.activeElement;
      const fadeHeight = (parseFloat(getComputedStyle(this.body).fontSize) || 14) * 2.4;
      const cutoff = this.body.getBoundingClientRect().top + this.previewHeight - fadeHeight;
      if (this.overflow && !this.expanded && active && this.body.contains(active) && active.getBoundingClientRect().bottom > cutoff) {
        this.expanded = true;
      }
      const collapsed = this.overflow && !this.expanded;
      this.classList.toggle('is-collapsed', Boolean(collapsed));
      this.button.hidden = !this.overflow;
      this.button.setAttribute('aria-expanded', String(!collapsed));
      this.button.textContent = collapsed ? this.dataset.moreLabel : this.dataset.lessLabel;
      if (!collapsed) return;
      this.body.querySelectorAll(focusSelector).forEach(node => {
        if (node.getBoundingClientRect().bottom > cutoff) {
          this.savedTabs.set(node, node.getAttribute('tabindex'));
          node.setAttribute('tabindex', '-1');
        }
      });
    }
  }
  customElements.define('zoo-content-guide', ZooContentGuide);
})();
